import { render, staticRenderFns } from "./SerpGrid.vue?vue&type=template&id=e50a58b4&scoped=true&"
import script from "./SerpGrid.vue?vue&type=script&lang=js&"
export * from "./SerpGrid.vue?vue&type=script&lang=js&"
import style0 from "./SerpGrid.vue?vue&type=style&index=0&id=e50a58b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50a58b4",
  null
  
)

export default component.exports